import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9551 5.18353L18.9329 9.60827C19.8635 10.4355 20.3288 10.849 20.5002 11.3374C20.6508 11.7663 20.6508 12.2337 20.5002 12.6625C20.3288 13.1509 19.8635 13.5645 18.9329 14.3917L13.9551 18.8164C13.5328 19.1918 13.3216 19.3795 13.1423 19.3862C12.9865 19.392 12.8369 19.3249 12.7377 19.2045C12.6236 19.066 12.6236 18.7835 12.6236 18.2185V15.4286C10.1955 15.4286 7.63093 16.2084 5.75831 17.5928C4.78342 18.3135 4.29595 18.6738 4.11029 18.6596C3.92932 18.6458 3.81447 18.5751 3.72057 18.4197C3.62423 18.2604 3.70932 17.7625 3.87949 16.7667C4.98446 10.3005 9.43443 8.57141 12.6236 8.57141V5.78146C12.6236 5.21644 12.6236 4.93393 12.7377 4.79543C12.8369 4.67511 12.9865 4.60792 13.1423 4.61375C13.3216 4.62047 13.5328 4.80815 13.9551 5.18353Z"
        fill={colorValue}
      />
    </svg>
  );
};
